import React, { ButtonHTMLAttributes, HTMLProps, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { usePostDialogueData } from '../../../api/pension-robot/usePostPensionDialogueData';
import { Button } from '../../general/Button';
import { RobotEnvironmentContext } from '../../../contexts/general/RobotEnvironmentContext';
import { isMyBND } from '../../../utils/functions';
import { PensionProgressSaverContext } from './DialogueDataSaving/PensionProgressSaverContext';

export const NextButton: React.FC<
    { nextPage: string; isDisabled?: boolean } & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'size'>
> = ({ nextPage, className, isDisabled = false }) => {
    const { t } = useTranslation('pension');
    const history = useHistory();
    const { environment } = useContext(RobotEnvironmentContext);
    const query = usePostDialogueData();
    const {
        pensionProgressSaverData: { autoSaveMyBND },
    } = useContext(PensionProgressSaverContext);

    return (
        <Button
            id="next"
            buttonType="primary"
            onClick={() => {
                history.push(nextPage);
                isMyBND(environment) && autoSaveMyBND && query.refetch();
            }}
            className={`${className} px-8`}
            isDisabled={isDisabled}
            showWobbleArrow={true}
            wobbleArrowType={'right'}
        >
            {t('general-next')}
        </Button>
    );
};

export const BackButton: React.FC<HTMLProps<HTMLDivElement>> = ({ className }) => {
    const { t } = useTranslation('pension');
    const history = useHistory();
    return (
        <Button
            id="previous"
            buttonType="secondary"
            onClick={() => {
                history.goBack();
            }}
            className={`${className} px-8`}
            showWobbleArrow={true}
            wobbleArrowType={'left'}
        >
            {t('general-back')}
        </Button>
    );
};
